import type { Language } from "@app/constants";

interface Messages {
	heading: string;
	fiaTooltipHeading: string;
	sdaTooltipHeading: string;
	reserved: string;
	available: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		heading: "Allowances",
		fiaTooltipHeading: "AIT (FIA) Details: ",
		sdaTooltipHeading: "SDA Details: ",
		reserved: "Reserved",
		available: "Available",
	},
};

export default messages;
